import { lazyImport as trebleLazyImport } from 'treble-fetch';

const lazyImport = (dynamicImport: () => any) => trebleLazyImport(dynamicImport);

export default lazyImport;